export const HOME = "/";
export const LOGIN = "/login";
export const ZODIAC_WHAT_IS = "/zodiac/what-is";
export const ZODIAC_LIST = "/zodiac/sign-list";
export const ZODIAC_SIGN_QUIZ = "/zodiac/sign-quiz";
export const ZODIAC_CONSTELLATIONS_QUIZ = "/zodiac/constellations-quiz";
export const ZODIAC_LOVE_COMPATIBILITY = "/zodiac/love-compatibility";
export const ZODIAC_CALENDAR = "/zodiac/calendar";
export const ZODIAC_DAILY_HOROSCOPE = "/zodiac/daily-horoscope";
export const ZODIAC_RANKING_OF_CONSTELLATIONS =
  "/zodiac/ranking-of-constellations";
export const NUMEROLOGY_WHAT_IS = "/numerology/what-is";
export const NUMEROLOGY_MEANING_OF_NUMBERS = "/numerology/meaning-of-numbers";
export const NUMEROLOGY_MEANING_OF_ANGEL_NUMBERS =
  "/numerology/meaning-of-angel-numbers";
export const NUMEROLOGY_MASTER_NUMBERS = "/numerology/master-numbers";

export const NUMEROLOGY_INDICATORS_LIFE_PATH =
  "/numerology/indicators-life-path";
export const NUMEROLOGY_INDICATORS_EXPRESSION =
  "/numerology/indicators-expression";
export const NUMEROLOGY_INDICATORS_BIRTHDAY = "/numerology/indicators-birthday";
export const NUMEROLOGY_INDICATORS_NAME = "/numerology/indicators-name";
export const NUMEROLOGY_INDICATORS_COMPATIBILITY =
  "/numerology/indicators-compatibility";
export const NUMEROLOGY_LIST_NUMBERS = "/numerology/list-numbers";
export const NUMEROLOGY_DAILY_NUMBER = "/numerology/daily-number";


export const TAROT_WHAT_IS = "/tarot/what-is";
export const TAROT_DECKS = "/tarot/decks";
export const TAROT_DAILY_CARD = "/tarot/daily-card";
export const TAROT_DAILY_LOVE_TAROT = "/tarot/daily-love-tarot";
export const TAROT_YES_NO_TAROT = "/tarot/yes-no";
export const TAROT_ONE_CARD_TAROT_READING = "/tarot/one-card-tarot-reading";
